import React from "react";
import { CashReceiptContainer } from "../styled";

const CashReceipt = () => {
  return (
    <CashReceiptContainer>
      <p className="title">
        <span>현금영수증</span>
        <button>변경하기</button>
      </p>
      <div>
        <span>발급여부</span>
        <span>미발급</span>
      </div>
    </CashReceiptContainer>
  );
};

export default CashReceipt;
